var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"input-group",attrs:{"id":_vm.id + '__fb_sectionGroup__'}},[_vm._t("prepend"),_vm._t("default"),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }